import React from 'react';
import { ColumnSizing } from '../tables-context';
import { MRT_ColumnDef } from 'material-react-table';
import { TableCell } from '../../../components/table/TableCell';
import { numberFormatter } from '../../../utils/utilities';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import { IMockProps } from './partners-commissions-data';

export enum MainCommissionsDataTableAccessorKeys {
	name = 'name',
	activeMerchants = 'activeMerchants',
	grossRevenue = 'grossRevenue',
	netRevenue = 'netRevenue',
	transactions = 'transactions',
	total = 'total',
	status = 'status',
	id = 'id',
}

export const defaultMainCommissionsColumnSizing: ColumnSizing = {
	[MainCommissionsDataTableAccessorKeys.name]: 100,
	[MainCommissionsDataTableAccessorKeys.activeMerchants]: 100,
	[MainCommissionsDataTableAccessorKeys.grossRevenue]: 100,
	[MainCommissionsDataTableAccessorKeys.netRevenue]: 100,
	[MainCommissionsDataTableAccessorKeys.transactions]: 100,
	[MainCommissionsDataTableAccessorKeys.total]: 100,
	[MainCommissionsDataTableAccessorKeys.status]: 100,
	[MainCommissionsDataTableAccessorKeys.id]: 50,
};

const getTableAmount = (value: number): JSX.Element => (
	<div className="fs-7 fc-text-overflow fw-bolder">
		{value ? `$${numberFormatter(value)}` : '-'}
	</div>
);

export const defaultMainCommissionsColumns: MRT_ColumnDef<IMockProps>[] = [
	{
		accessorKey: MainCommissionsDataTableAccessorKeys.name,
		header: 'Name',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Name</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="d-flex align-items-center main-font-family text-black"
				density={table?.options?.state?.density}
				isTextOverflow={false}
			>
				<Link
					to={`#`}
					target="_blank"
					className="text-black fw-bolder cursor-pointer main-font-family text-danger fc-merchant-name-link fc-text-overflow"
				>
					{renderedCellValue}
					<FontAwesomeIcon icon={faArrowUpRightFromSquare} className="ms-2 w-10px"/>
				</Link>
			</TableCell>
		)
	},
	{
		accessorKey: MainCommissionsDataTableAccessorKeys.activeMerchants,
		header: 'Active merchants',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Active merchants</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="d-flex align-items-center main-font-family text-black"
				density={table?.options?.state?.density}
				isTextOverflow={false}
			>
				{getTableAmount(renderedCellValue)}
			</TableCell>
		)
	},
	{
		accessorKey: MainCommissionsDataTableAccessorKeys.grossRevenue,
		header: 'Commission on gross revenue',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Commission on gross revenue</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="d-flex align-items-center main-font-family text-black"
				density={table?.options?.state?.density}
				isTextOverflow={false}
			>
				{getTableAmount(renderedCellValue)}
			</TableCell>
		)
	},
	{
		accessorKey: MainCommissionsDataTableAccessorKeys.netRevenue,
		header: 'Commissions on net revenue',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Commissions on net revenue</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="d-flex align-items-center main-font-family text-black"
				density={table?.options?.state?.density}
				isTextOverflow={false}
			>
				{getTableAmount(renderedCellValue)}
			</TableCell>
		)
	},
	{
		accessorKey: MainCommissionsDataTableAccessorKeys.transactions,
		header: 'Commissions on orders',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Commissions on orders</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="d-flex align-items-center main-font-family text-black"
				density={table?.options?.state?.density}
				isTextOverflow={false}
			>
				{getTableAmount(renderedCellValue)}
			</TableCell>
		)
	},
	{
		accessorKey: MainCommissionsDataTableAccessorKeys.total,
		header: 'Total commissions',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Total commissions</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="d-flex align-items-center main-font-family text-black"
				density={table?.options?.state?.density}
				isTextOverflow={false}
			>
				{getTableAmount(renderedCellValue)}
			</TableCell>
		)
	},
];


